module.exports = __webpack_public_path__ + "img/goin-bg04.09d06b6a.jpg";